import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function locationsReducer(
  state = initialState.locations,
  action
) {
  switch (action.type) {
    case types.LOAD_LOCATIONS_SUCCESS:
      return action.locations;
    case types.RESET_LOCATIONS_SUCCESS:
      return initialState.locations;
    default:
      return state;
  }
}
